const apply = [
  {
    path: '/apply/vacation',
    component: () => import('@/mobile/page/apply/vacation'),
    meta: {
      name: '휴가',
    },
  },
  {
    path: '/apply/workhome',
    component: () => import('@/mobile/page/apply/workhome'),
    meta: {
      name: '재택근무',
    },
  },
  {
    path: '/apply/outside',
    component: () => import('@/mobile/page/apply/outside'),
    meta: {
      name: '출장 / 외근',
    },
  },
];

export default apply;
